import {
  Button, Dialog, DialogContent, Fab, Slide, Typography,
} from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import { Trans, useTranslation } from 'react-i18next';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import WavyDialogBackground from '../../atoms/WavyDialogBackground';

const useStyles = makeStyles()(() => ({
  content: {
    maxWidth: 400,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '.5em',
  },
  button: {
    width: '100%',
    background: '#3b8daa',
    color: 'white',
    '&hover': {
      background: '#255d70',
    },
  },
  title: {
    margin: '3em 0',
  },
}));

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
  ) => {
    return <Slide direction="up" ref={ref} {...props} timeout={700} />;
  },
);
export interface LoginRequiredDialogProps {
  onClose: () => void;
  open: boolean;
}

const LoginRequiredDialog: React.FC<LoginRequiredDialogProps> = ({
  onClose,
  open,
}: LoginRequiredDialogProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const goToRegister = () => {
    window.location.href = `https://auth.klang.io/register?redirect_url=${window.location.href}&source=popup`;
  };
  const goToLogin = () => {
    window.location.href = `https://auth.klang.io/login?redirect_url=${window.location.href}&source=popup`;
  };

  return (
    <Dialog open={open} onClose={onClose} TransitionComponent={Transition}>
      <WavyDialogBackground />
      <DialogContent className={classes.content}>
        <Typography className={classes.title} variant="h5">
          <Trans components={{ strong: <strong /> }}>{t('dialog.login_required.teaser')}</Trans>
        </Typography>
        <Typography color="secondary" variant="body1">
          {t('dialog.login_required.subteaser')}
        </Typography>

        <Fab
          id="btn_file_register"
          variant="extended"
          color="secondary"
          onClick={goToRegister}
          className={classes.button}
        >
          {t('dialog.login_required.sign_up')}
        </Fab>
        <Button id="btn_file_login" onClick={goToLogin}>
          {t('dialog.login_required.login')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default LoginRequiredDialog;
